import cx from 'classnames'
import { ReactNode } from 'react'
import { SanityButtonStyle } from '@data/sanity/queries/types/link'
import { SanityColor } from '@data/sanity/queries/types/modules'
import { ButtonSize } from '@components/buttons/button'
import { linkFrameColorClasses } from '@lib/link'

interface LinkFrameProps {
  buttonStyles: SanityButtonStyle
  children: ReactNode
}

const LinkFrame = ({ buttonStyles, children }: LinkFrameProps) => {
  return (
    <div
      className={cx(
        'relative inline-flex',
        buttonStyles.color
          ? linkFrameColorClasses[buttonStyles.color as SanityColor]
          : undefined,
        {
          'p-2': buttonStyles.size === ButtonSize.SMALL,
          'p-4': buttonStyles.size === ButtonSize.NORMAL,
          'p-8 md:p-10': buttonStyles.size === ButtonSize.LARGE,
        },
      )}
    >
      <svg
        className="absolute top-[50%] translate-y-[-50%] inset-x-0 w-full"
        viewBox="0 0 680 220"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M670 0H610V10H670L670 70H680V10V0H670Z"
          className="fill-current"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M680 210L680 150L670 150L670 210L610 210L610 220L670 220L680 220L680 210Z"
          className="fill-current"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 220L70 220L70 210L10 210L10 150L6.11959e-06 150L8.74228e-07 210L0 220L10 220Z"
          className="fill-current"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.86805e-06 10L0 70L10 70L10 10L70 10L70 9.17939e-06L10 1.31134e-06L9.17939e-06 0L7.86805e-06 10Z"
          className="fill-current"
        />
      </svg>

      <div className="relative inline-flex z-1">{children}</div>
    </div>
  )
}

export default LinkFrame
